import React, { FC } from 'react'
import styles from 'styles/components/tag.module.scss'

type Props = {
  shape?: 'ellipse' | 'square'
  size?: 'medium' | 'large'
  tagName: string
}

const GreyTag: FC<Props> = (props) => {
  const { shape, size, tagName } = props
  const baseStyle = styles.tag_grey
  const shapeStyle = shape === 'ellipse' ? styles.tag__ellipse : ''
  const sizeStyle = size === 'large' ? styles.tag_large : ''

  return <span className={`${baseStyle} ${shapeStyle} ${sizeStyle}`}>{tagName}</span>
}

export default GreyTag
